<!-- ----------------------------------------------- -->
<template>
  <v-card :flat="isSmall" class="com-mb-card" :class="isSmall ? 'mt-0' : ''">
    <v-col v-show="!isSmall" class="com-mb-card-contents py-1">
      <v-row justify="center" class="mt-2">
        <v-btn
          class="rd-movie-button"
          rounded
          depressed
          :outlined="!isMovieTime(0)"
          :disabled="!isNotPlay"
          color="success"
          @click="setMovieTime(0)"
        >
          <span>{{ text.interval5 }}</span>
        </v-btn>
        <v-btn
          class="ms-2 rd-movie-button"
          rounded
          depressed
          :outlined="!isMovieTime(1)"
          :disabled="!isNotPlay"
          color="success"
          @click="setMovieTime(1)"
        >
          <span>{{ text.interval30 }}</span>
        </v-btn>
        <v-btn
          class="ms-2 rd-movie-button"
          rounded
          depressed
          :outlined="!isMovieTime(2)"
          :disabled="!isNotPlay"
          color="success"
          @click="setMovieTime(2)"
        >
          <span>{{ text.interval60 }}</span>
        </v-btn>
      </v-row>
      <v-row justify="center" class="pt-2">
        <v-btn
          v-show="isNotPlay"
          small
          rounded
          depressed
          outlined
          color="success"
          @click="readyRadar()"
        >
          <v-icon left color="success">play_arrow</v-icon>
          <span>{{ text.play }}</span>
        </v-btn>
        <v-btn
          v-show="isReady"
          small
          rounded
          depressed
          outlined
          loading
          color="success"
        >
          <v-icon left color="success">play_arrow</v-icon>
          <span>{{ text.play }}</span>
        </v-btn>
        <v-btn
          v-show="isPlay"
          small
          rounded
          depressed
          outlined
          color="success"
          @click="stopPlay()"
        >
          <v-icon left color="red">pause</v-icon>
          <span class="red--text">{{ text.stop }}</span>
        </v-btn>
      </v-row>
      <v-row justify="center" class="pl-4 pr-4 pb-2">
        <v-slider
          v-model="moviePos"
          small
          tick-size="0"
          :tick-labels="sliderLabel"
          :thumb-color="sliderThumbColor"
          :max="sliderMax"
          min="0"
          step="1"
          :disabled="isSliderDisable"
          class="rd-movie-slider"
        >
          <template v-slot:prepend>
            <v-icon
              :color="isSliderDisable ? 'disable' : 'success'"
              @click="fastRewind"
              >fast_rewind</v-icon
            >
          </template>
          <template v-slot:append>
            <v-icon
              :color="isSliderDisable ? 'disable' : 'success'"
              @click="fastForward"
              >fast_forward</v-icon
            >
          </template>
        </v-slider>
      </v-row>
    </v-col>
    <v-col v-show="isSmall" class="com-mb-card-contents-none-border px-1 pt-4">
      <v-row justify="center" class="pl-4 pr-2 rd-movei-slider">
        <v-slider
          v-model="moviePos"
          tick-size="0"
          :tick-labels="sliderLabel"
          :thumb-color="sliderThumbColor"
          :max="sliderMax"
          min="0"
          step="1"
          class="pr-4"
          :disabled="isSliderDisable"
        >
          <template v-slot:prepend>
            <v-icon
              :color="isSliderDisable ? 'disable' : 'success'"
              @click="fastRewind"
              >fast_rewind</v-icon
            >
          </template>
          <template v-slot:append>
            <v-icon
              :color="isSliderDisable ? 'disable' : 'success'"
              @click="fastForward"
              >fast_forward</v-icon
            >
          </template>
        </v-slider>
        <v-btn
          v-show="isNotPlay"
          rounded
          depressed
          outlined
          small
          color="success"
          @click="readyRadar()"
        >
          <v-icon color="success">play_arrow</v-icon>
        </v-btn>
        <v-btn
          v-show="isReady"
          rounded
          depressed
          outlined
          loading
          color="success"
        >
          <v-icon color="success">play_arrow</v-icon>
        </v-btn>
        <v-btn
          v-show="isPlay"
          rounded
          depressed
          outlined
          small
          color="success"
          @click="stopPlay()"
        >
          <v-icon color="red">pause</v-icon>
        </v-btn>
      </v-row>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [mb]レーダ雨量画面 履歴動画再生カード
 * RdMovie.vue
 * @author LIS
 */
import mixin from "./../../lib/mixin";
import Util from "./../../lib/util";
import PageLog from "./../../lib/pageLog.js";
import { setInterval, clearInterval } from "timers";

export default {
  name: "rd-movie",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "履歴動画再生",
        interval5: "５分間隔",
        interval30: "３０分間隔",
        interval60: "６０分間隔",
        play: "再生",
        stop: "停止",
      },
      /** 再生時間 */
      movieTime: 0,
      /** 再生時間 */
      movieInterval: [60, 180, 360],
      /** 再生タイマID */
      movieTimerId: 0,
      /** 再生終了時間 */
      endTime: new Date(),
      /** 履歴動画再生間隔(ms) */
      wait: 2000,
      /** スライダーラベル */
      sliderLabel: [],
    };
  },
  props: {
    isSmall: { default: false, type: Boolean },
  },
  created() {
    this.$log.debug("[RdMovie] created()");
    /* 履歴動画再生間隔を設定ファイルから取得 */
    this.wait = this.frameInterval;
    /* 再生終了時間取得 */
    this.endTime = this.appTime.time;
    /* 再生終了時間設定 */
    this.$store.commit("radar/setHistoryPlayTime", this.appTime.time);
    /* 再生時間設定 */
    this.movieTime = 0;
    this.$store.commit("radar/setHistoryMovieTime", this.movieTime);
    /* スライダーラベル生成 */
    this.makeTickLabels();
  },
  beforeDestroy() {
    this.$log.debug("[RdMovie] beforeDestroy()");
    /* 再生を停止する */
    this.endMovie();
    this.$store.commit("radar/resetHistoryPlay");
  },
  computed: {
    /** 観測日時 */
    appTime: {
      get() {
        const current = {
          time: this.$store.state.app.appTime,
          flag: this.$store.state.app.isCurrent,
        };
        return current;
      },
    },
    /** ズームレベル */
    mapZoom: {
      get() {
        return this.$store.state.map.zoom;
      },
    },
    /** 地図右上座標 */
    maxCoord: {
      get() {
        return this.$store.state.map.maxCoord;
      },
    },
    /** 地図左下座標 */
    minCoord: {
      get() {
        return this.$store.state.map.minCoord;
      },
    },
    /** 再生コマ表示間隔 */
    frameInterval: {
      get() {
        return this.$store.state.radar.historyPlayFrameInterval;
      },
    },
    /** レーダ種別 */
    radarType: {
      get() {
        return this.$store.state.radar.radarType;
      },
    },
    /** 再生位置 */
    moviePos: {
      get() {
        return this.$store.state.radar.historyCurrentFrame;
      },
      set(val) {
        this.$store.commit("radar/setHistoryCurrentFrame", val);
      },
    },
    /** 履歴再生リスト */
    historyPlayList: {
      get() {
        return this.$store.state.radar.historyPlayList;
      },
    },
    /** 再生時間間隔 */
    historyInterval: {
      get() {
        return this.$store.state.radar.historyInterval;
      },
    },
    /** 再生コマ数取得 */
    historyPlayFrame: {
      get() {
        return this.$store.state.radar.historyPlayFrame;
      },
    },
    /** レーダ観測日時パラメータ */
    radarDateParam: {
      get() {
        return this.$store.state.radar.radarDateParam;
      },
    },
    /** 再生状態 */
    playStatus: {
      get() {
        return this.$store.state.radar.historyPlayStatus;
      },
      set(val) {
        this.$store.commit("radar/setHistoryPlayStatus", val);
      },
    },
    /** 履歴再生中状態 */
    isPlay: {
      get() {
        return this.$store.getters["radar/isPlay"];
      },
    },
    /** 履歴停止中以外状態 */
    isReady: {
      get() {
        return this.$store.getters["radar/isReady"];
      },
    },
    /** 履歴停止中状態 */
    isStop: {
      get() {
        return this.$store.getters["radar/isStop"];
      },
    },
    /** 履歴動画再生/準備中以外状態 */
    isNotPlay: {
      get() {
        return this.$store.getters["radar/isNotPlay"];
      },
    },
    /** 履歴動画未再生状態 */
    isNone: {
      get() {
        return this.$store.getters["radar/isNone"];
      },
    },
    /** 履歴動画終了時刻 */
    historyPlayEndTime: {
      get() {
        return this.$store.getters["radar/historyPlayEndTime"];
      },
    },
    /* スライダー有効判定 */
    isSliderDisable: {
      get() {
        return this.isReady || this.isNone;
      },
    },
    /* スライダー色 */
    sliderThumbColor: {
      get() {
        let color = "success";
        if (this.isPlay) {
          color = "red";
        }
        if (this.isSliderDisable) {
          color = "disable";
        }
        return color;
      },
    },
    /* スライダー最大値 */
    sliderMax: {
      get() {
        return this.historyPlayFrame - 1;
      },
    },
  },
  methods: {
    /* スライダーラベル生成 */
    makeTickLabels() {
      let labels = [];
      if (!this.isSmall) {
        let end = this.historyPlayEndTime;
        labels.push(Util.formatDate24(end, "HH:mm"));
        for (let i = 1; i < this.historyPlayFrame - 1; i++) {
          labels.push("");
        }
        let fraction =
          Number(Util.formatDate(end, "mm")) % this.historyInterval;
        if (fraction == 0) {
          fraction = this.historyInterval;
        }
        let sub =
          this.movieInterval[this.movieTime] - this.historyInterval + fraction;
        labels.push(Util.formatDate24(Util.subMinutes(end, sub), "HH:mm"));
      }
      this.sliderLabel = labels.reverse();
    },
    /** 再生時間設定 */
    setMovieTime(val) {
      this.$log.debug("[RdMovie] setMovieTime()");
      this.movieTime = val;
      this.moviePos = 0;
      this.$store.commit("radar/resetHistoryPlay");
      this.$store.commit("radar/setHistoryMovieTime", this.movieTime);
      /* スライダーラベル生成 */
      this.makeTickLabels();
    },
    /** 再生終了判定 */
    isMovieTime(val) {
      return this.movieTime === val;
    },
    /** 再生準備 */
    readyRadar() {
      this.$log.debug("[RdMovie] readyRadar()");
      if (this.isNone || this.moviePos >= this.sliderMax) {
        this.moviePos = 0;
      }
      this.playStatus = "readyRadar";
      this.$store.dispatch("radar/requestHistoryPlayRadarImage", {
        zoom: this.mapZoom,
        maxCoord: this.maxCoord,
        minCoord: this.minCoord,
      });
    },
    /** 停止 */
    stopPlay() {
      this.$log.debug("[RdMovie] stopPlay()");
      this.playStatus = "stop";
      this.endMovie();
    },
    /** コマ送り */
    fastForward() {
      this.$log.debug("[RdMovie] fastForward()");
      this.moviePos++;
      if (this.isPlay || this.isStop) {
        this.$store.commit(
          "app/setTime",
          Util.toDate(this.historyPlayList[this.moviePos])
        );
      }
    },
    /** コマ戻り */
    fastRewind() {
      this.$log.debug("[RdMovie] fastRewind()");
      this.moviePos--;
      if (this.isPlay || this.isStop) {
        this.$store.commit(
          "app/setTime",
          Util.toDate(this.historyPlayList[this.moviePos])
        );
      }
    },
    /** 再生開始 */
    startMovie() {
      this.$log.debug("[RdMovie] startMovie()");
      // アクセスログ出力
      PageLog.log({
        page_log: "radar_movie",
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        rader_sb: this.$store.state.radar.radarType,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.endMovie();
      if (null !== this.historyPlayList) {
        this.$store.commit(
          "app/setTime",
          Util.toDate(this.historyPlayList[this.moviePos])
        );
        this.movieTimerId = setInterval(() => {
          this.moviePos++;
          this.$store.commit(
            "app/setTime",
            Util.toDate(this.historyPlayList[this.moviePos])
          );
          if (this.moviePos >= this.historyPlayFrame) {
            this.playStatus = "stop";
            this.endMovie();
          }
        }, this.wait);
      }
    },
    /** 再生終了 */
    endMovie() {
      this.$log.debug("[RdMovie] endMovie()");
      if (this.movieTimerId != 0) {
        this.$log.debug("[RdMovie] clearInterval()");
        clearInterval(this.movieTimerId);
        this.movieTimerId = 0;
      }
    },
  },
  watch: {
    playStatus() {
      this.$log.debug("[RdMovie]watch - playStatus");
      if (this.isPlay) {
        this.startMovie();
      }
      // 再生停止したタイミングでURLパラメータ更新
      if (this.isStop) {
        this.replaceRadarQueryForMb();
      }
    },
    appTime() {
      this.$log.debug("[RdMovie]watch - appTime");
      if (this.isNone) {
        /* 再生終了時間取得 */
        this.endTime = this.appTime.time;
        this.$store.commit("radar/resetHistoryPlay");
        this.$store.commit("radar/setHistoryMovieTime", this.movieTime);
        this.$store.commit("radar/setHistoryPlayTime", this.appTime.time);
        /* レーダ観測日時取得要求 */
        this.$store.dispatch("radar/requestRadarDate", {
          time: this.endTime,
          current: this.appTime.flag,
        });
        this.replaceRadarQueryForMb();
      }
    },
    moviePos() {
      this.$log.debug("[RdMovie]watch - moviePos");
      if (this.isStop) {
        this.$store.commit(
          "app/setTime",
          Util.toDate(this.historyPlayList[this.moviePos])
        );
      }
    },
    isSmall() {
      this.$log.debug("[RdMovie]watch - isSmall");
      /* スライダーラベル生成 */
      this.makeTickLabels();
    },
    radarType() {
      this.$log.debug("[RdMovie]watch - radarType");
      /* スライダーラベル生成 */
      this.makeTickLabels();
    },
    radarDateParam() {
      this.$log.debug("[RdMovie]watch - radarDateParam");
      /* スライダーラベル生成 */
      this.makeTickLabels();
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.rd-movie-slider {
  height: 30pt;
}

.rd-movie-button {
  width: 76px;
  height: 24px !important;
  font-size: 8pt;
  padding-left: 16px;
}
</style>
